<template>
	<tbody>
		<tr :class="'css' + event.status + ' ' + (event.new ? 'new' : '')">
			<td>
				<div style="display:inline-block;height:10px;width:10px;border-radius: 5px;"
					:style="event.read ? 'background:transparent;' : 'background:white;'"></div> {{
						event.date }} {{
					event.status }}: {{
					event.message }}
			</td>
		</tr>
	</tbody>
</template>


<script>
export default {
	name: "EventLog",
	props: {
		event: Object
	},
	components: {},
	data() {
		return {
			result: null
		};
	},
	computed: {
		eventLogList() {
			return this.$store.state.eventLogList;
		}
	},
	methods: {}
};
</script>

<style scoped>
tbody tr.cssOK td {
	background: var(--bg-ok);
}

tbody tr.cssOK.new td {
	background: var(--bg-ok-light);
}

tbody tr.cssWARNING td {
	background: var(--bg-warning);
}

tbody tr.cssWARNING.new td {
	background: var(--bg-warning-light);
}

tbody tr.cssERROR td {
	background: var(--bg-error);
}

tbody tr.cssERROR.new td {
	background: var(--bg-error-light);
}

tbody tr.cssINFO td {
	background: var(--bg-message);
}

tbody tr.cssINFO.new td {
	background: var(--bg-message-light);
}

tbody tr.cssDEBUG td {
	background: var(--bg-debug);
}

tbody tr.cssDEBUG.new td {
	background: var(--bg-debug-light);
}

tr td {
	padding: 5px;
	background: var(--light);
	border-radius: 5px;
	color: var(--font-color-light);
}
</style>